/*!
* @nutui/nutui v3.3.6 Fri Mar 10 2023 14:47:39 GMT+0800 (中国标准时间)
* (c) 2022 @jdf2e.
* Released under the MIT License.
*/
class BaseLang {
}
export { BaseLang as B };
